import { actionTypes } from '../actions/contactForm'

const initial = {
	name: '',
	phone: '',
  email: '',
	query: '',
  sector: '',
  property_code: '',
  broker_id: '',
  director_id: '',
  subsidiary_id: '',
  sector_id: '',
  officeName: '',
  pathName: '',
  send: false,
  branch: null,
}

export default (state = initial, action) => {
  switch (action.type) {
  	case actionTypes.SEND_INFO:
      return Object.assign({}, state, {
      	name: action.data.name,
      	phone: action.data.phone,
        email: action.data.email,
      	query: action.data.query,
        sector: action.data.sector,
        property_code: action.info.property_code,
        broker_id: action.info.broker,
        director_id: action.info.director,
        subsidiary_id: action.info.subsidiary,
        sector_id: action.info.sector,
        officeName: action.info.officeName,
        pathName: action.info.pathName,
        send: true,
        property_type: action.info.property_type,
        operation_type: action.info.operation_type,
        branch: action.info.branch,
    })

    case actionTypes.RESET_FORM:
      return Object.assign({}, state, {
        name: '',
        phone: '',
        email: '',
        query: '',
        sector: '',
        property_code: '',
        broker_id: '',
        director_id: '',
        officeName: '',
        pathName: '',
        branch: null,
        send: false
    })

  	default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/contactForm.js